import { PAYMENT_TYPES } from '@vend/business-components'
import { useAppSelector } from '../../../../state/hooks'
import { selectTotalPartialPayments } from '../../../../state/slices/currentSale/currentSaleSlice'

/**
 * Returns true when the current sale has a net positive On Account payment applied.
 *
 * Net-total based: if an On Account charge has since been fully refunded (net
 * total <= 0), this returns false — used by tax-breakdown controls to decide
 * whether tax can still be edited, which should be allowed again once the
 * On Account balance is no longer outstanding.
 *
 * For a presence-based check (e.g. Layaway eligibility, where any On Account
 * entry — even a fully-refunded one — must permanently block Layaway), use
 * useHasOnAccountPaymentEntry instead.
 */
export const useHasOnAccountPayment = (): boolean =>
  // includeRetrievedPayments: true — when a parked/on-account sale is continued, its
  // existing payments are loaded from the API and flagged retrieved: true to distinguish
  // them from new payments added in the current session. The selector excludes retrieved
  // payments by default, so we must opt in to catch these API-hydrated payments.
  useAppSelector(selectTotalPartialPayments(PAYMENT_TYPES.ON_ACCOUNT, true)) > 0
